var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid grey"}},[_c('pre',{staticClass:"mini-pre"},[_vm._v(_vm._s(_vm.message.$state))])])}
var staticRenderFns = []

export { render, staticRenderFns }